import axios from 'axios'
import { useAuth } from '@clerk/clerk-react'

const API_URL = (import.meta.env.VITE_API_URL) || 'http://localhost:8080/api/v1'

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Hook to setup axios interceptor with Clerk auth
export function useApiInterceptor() {
  const { getToken } = useAuth()

  api.interceptors.request.use(
    async (config) => {
      try {
        const token = await getToken()
        if (token) {
          config.headers.Authorization = `Bearer ${token}`
        }
      } catch (error) {
        console.error('Error getting auth token:', error)
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  api.interceptors.response.use(
    (response) => response,
    (error: unknown) => {
      if (axios.isAxiosError(error) && error.response?.status === 401) {
        // Token might be expired, Clerk will handle refresh
        window.location.href = '/sign-in'
      }
      return Promise.reject(error)
    }
  )
}

// API service functions
export const memberService = {
  getAll: () => api.get('/members'),
  getById: (id: string) => api.get(`/members/${id}`),
  create: (data: unknown) => api.post('/members', data),
  update: (id: string, data: unknown) => api.put(`/members/${id}`, data),
  delete: (id: string) => api.delete(`/members/${id}`),
}

export const contributionService = {
  getAll: () => api.get('/contributions'),
  getByMemberId: (memberId: string) => api.get(`/contributions/member/${memberId}`),
  create: (data: unknown) => api.post('/contributions', data),
}

export const healthService = {
  check: () => api.get('/health'),
  version: () => api.get('/version'),
}